import type { BillingPlan, OnboardingPricing } from "./api";

export function formatMoney(cents: number, currency = "usd"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(cents / 100);
}

/** e.g. "$25.00/week" or "$99.99/month". */
export function recurringLabel(
  plan: BillingPlan,
  pricing: OnboardingPricing,
): string {
  const amount = formatMoney(pricing.recurringCents[plan], pricing.currency);
  return plan === "monthly" ? `${amount}/month` : `${amount}/week`;
}

export function planName(plan: BillingPlan): string {
  return plan === "monthly" ? "Monthly" : "Weekly";
}
